const timezones = [
    // Asia
    { label: 'India (IST) UTC+5:30', value: 'Asia/Kolkata' },
    { label: 'Pakistan (PKT) UTC+5:00', value: 'Asia/Karachi' },
    { label: 'Bangladesh (BST) UTC+6:00', value: 'Asia/Dhaka' },
    { label: 'Sri Lanka (IST) UTC+5:30', value: 'Asia/Colombo' },
    { label: 'Nepal (NPT) UTC+5:45', value: 'Asia/Kathmandu' },
    { label: 'Dubai / UAE (GST) UTC+4:00', value: 'Asia/Dubai' },
    { label: 'Saudi Arabia (AST) UTC+3:00', value: 'Asia/Riyadh' },
    { label: 'Qatar (AST) UTC+3:00', value: 'Asia/Qatar' },
    { label: 'Kuwait (AST) UTC+3:00', value: 'Asia/Kuwait' },
    { label: 'Bahrain (AST) UTC+3:00', value: 'Asia/Bahrain' },
    { label: 'Oman (GST) UTC+4:00', value: 'Asia/Muscat' },
    { label: 'Iran (IRST) UTC+3:30', value: 'Asia/Tehran' },
    { label: 'Israel (IST) UTC+2:00', value: 'Asia/Jerusalem' },
    { label: 'Turkey (TRT) UTC+3:00', value: 'Europe/Istanbul' },
    { label: 'Singapore (SGT) UTC+8:00', value: 'Asia/Singapore' },
    { label: 'Malaysia (MYT) UTC+8:00', value: 'Asia/Kuala_Lumpur' },
    { label: 'Thailand (ICT) UTC+7:00', value: 'Asia/Bangkok' },
    { label: 'Vietnam (ICT) UTC+7:00', value: 'Asia/Ho_Chi_Minh' },
    { label: 'Indonesia - Jakarta (WIB) UTC+7:00', value: 'Asia/Jakarta' },
    { label: 'Philippines (PHT) UTC+8:00', value: 'Asia/Manila' },
    { label: 'China (CST) UTC+8:00', value: 'Asia/Shanghai' },
    { label: 'Hong Kong (HKT) UTC+8:00', value: 'Asia/Hong_Kong' },
    { label: 'Taiwan (CST) UTC+8:00', value: 'Asia/Taipei' },
    { label: 'Japan (JST) UTC+9:00', value: 'Asia/Tokyo' },
    { label: 'South Korea (KST) UTC+9:00', value: 'Asia/Seoul' },
    { label: 'Myanmar (MMT) UTC+6:30', value: 'Asia/Yangon' },
    { label: 'Cambodia (ICT) UTC+7:00', value: 'Asia/Phnom_Penh' },
    { label: 'Afghanistan (AFT) UTC+4:30', value: 'Asia/Kabul' },
    { label: 'Uzbekistan (UZT) UTC+5:00', value: 'Asia/Tashkent' },
    { label: 'Kazakhstan - Almaty (ALMT) UTC+6:00', value: 'Asia/Almaty' },
    { label: 'Georgia (GET) UTC+4:00', value: 'Asia/Tbilisi' },
    { label: 'Armenia (AMT) UTC+4:00', value: 'Asia/Yerevan' },
    { label: 'Azerbaijan (AZT) UTC+4:00', value: 'Asia/Baku' },

    // Europe
    { label: 'UK / London (GMT/BST) UTC+0:00', value: 'Europe/London' },
    { label: 'Ireland (GMT/IST) UTC+0:00', value: 'Europe/Dublin' },
    { label: 'France (CET) UTC+1:00', value: 'Europe/Paris' },
    { label: 'Germany (CET) UTC+1:00', value: 'Europe/Berlin' },
    { label: 'Netherlands (CET) UTC+1:00', value: 'Europe/Amsterdam' },
    { label: 'Belgium (CET) UTC+1:00', value: 'Europe/Brussels' },
    { label: 'Spain (CET) UTC+1:00', value: 'Europe/Madrid' },
    { label: 'Italy (CET) UTC+1:00', value: 'Europe/Rome' },
    { label: 'Switzerland (CET) UTC+1:00', value: 'Europe/Zurich' },
    { label: 'Austria (CET) UTC+1:00', value: 'Europe/Vienna' },
    { label: 'Poland (CET) UTC+1:00', value: 'Europe/Warsaw' },
    { label: 'Czech Republic (CET) UTC+1:00', value: 'Europe/Prague' },
    { label: 'Sweden (CET) UTC+1:00', value: 'Europe/Stockholm' },
    { label: 'Norway (CET) UTC+1:00', value: 'Europe/Oslo' },
    { label: 'Denmark (CET) UTC+1:00', value: 'Europe/Copenhagen' },
    { label: 'Finland (EET) UTC+2:00', value: 'Europe/Helsinki' },
    { label: 'Greece (EET) UTC+2:00', value: 'Europe/Athens' },
    { label: 'Romania (EET) UTC+2:00', value: 'Europe/Bucharest' },
    { label: 'Bulgaria (EET) UTC+2:00', value: 'Europe/Sofia' },
    { label: 'Ukraine (EET) UTC+2:00', value: 'Europe/Kyiv' },
    { label: 'Portugal (WET) UTC+0:00', value: 'Europe/Lisbon' },
    { label: 'Russia - Moscow (MSK) UTC+3:00', value: 'Europe/Moscow' },
    { label: 'Russia - Yekaterinburg (YEKT) UTC+5:00', value: 'Asia/Yekaterinburg' },
    { label: 'Russia - Vladivostok (VLAT) UTC+10:00', value: 'Asia/Vladivostok' },

    // Americas
    { label: 'US Eastern (ET) UTC-5:00', value: 'America/New_York' },
    { label: 'US Central (CT) UTC-6:00', value: 'America/Chicago' },
    { label: 'US Mountain (MT) UTC-7:00', value: 'America/Denver' },
    { label: 'US Pacific (PT) UTC-8:00', value: 'America/Los_Angeles' },
    { label: 'US Alaska (AKT) UTC-9:00', value: 'America/Anchorage' },
    { label: 'US Hawaii (HST) UTC-10:00', value: 'Pacific/Honolulu' },
    { label: 'Canada - Toronto (ET) UTC-5:00', value: 'America/Toronto' },
    { label: 'Canada - Vancouver (PT) UTC-8:00', value: 'America/Vancouver' },
    { label: 'Canada - Edmonton (MT) UTC-7:00', value: 'America/Edmonton' },
    { label: 'Canada - Halifax (AT) UTC-4:00', value: 'America/Halifax' },
    { label: 'Mexico - Mexico City (CST) UTC-6:00', value: 'America/Mexico_City' },
    { label: 'Mexico - Tijuana (PT) UTC-8:00', value: 'America/Tijuana' },
    { label: 'Brazil - Sao Paulo (BRT) UTC-3:00', value: 'America/Sao_Paulo' },
    { label: 'Brazil - Manaus (AMT) UTC-4:00', value: 'America/Manaus' },
    { label: 'Argentina (ART) UTC-3:00', value: 'America/Argentina/Buenos_Aires' },
    { label: 'Chile (CLT) UTC-4:00', value: 'America/Santiago' },
    { label: 'Colombia (COT) UTC-5:00', value: 'America/Bogota' },
    { label: 'Peru (PET) UTC-5:00', value: 'America/Lima' },
    { label: 'Venezuela (VET) UTC-4:00', value: 'America/Caracas' },
    { label: 'Ecuador (ECT) UTC-5:00', value: 'America/Guayaquil' },
    { label: 'Panama (EST) UTC-5:00', value: 'America/Panama' },
    { label: 'Costa Rica (CST) UTC-6:00', value: 'America/Costa_Rica' },
    { label: 'Jamaica (EST) UTC-5:00', value: 'America/Jamaica' },
    { label: 'Puerto Rico (AST) UTC-4:00', value: 'America/Puerto_Rico' },
    { label: 'Dominican Republic (AST) UTC-4:00', value: 'America/Santo_Domingo' },
    { label: 'Trinidad & Tobago (AST) UTC-4:00', value: 'America/Port_of_Spain' },

    // Africa
    { label: 'Egypt (EET) UTC+2:00', value: 'Africa/Cairo' },
    { label: 'South Africa (SAST) UTC+2:00', value: 'Africa/Johannesburg' },
    { label: 'Nigeria (WAT) UTC+1:00', value: 'Africa/Lagos' },
    { label: 'Kenya (EAT) UTC+3:00', value: 'Africa/Nairobi' },
    { label: 'Ghana (GMT) UTC+0:00', value: 'Africa/Accra' },
    { label: 'Ethiopia (EAT) UTC+3:00', value: 'Africa/Addis_Ababa' },
    { label: 'Tanzania (EAT) UTC+3:00', value: 'Africa/Dar_es_Salaam' },
    { label: 'Morocco (WET) UTC+0:00', value: 'Africa/Casablanca' },
    { label: 'Algeria (CET) UTC+1:00', value: 'Africa/Algiers' },
    { label: 'Tunisia (CET) UTC+1:00', value: 'Africa/Tunis' },

    // Oceania
    { label: 'Australia - Sydney (AEST) UTC+10:00', value: 'Australia/Sydney' },
    { label: 'Australia - Melbourne (AEST) UTC+10:00', value: 'Australia/Melbourne' },
    { label: 'Australia - Brisbane (AEST) UTC+10:00', value: 'Australia/Brisbane' },
    { label: 'Australia - Perth (AWST) UTC+8:00', value: 'Australia/Perth' },
    { label: 'Australia - Adelaide (ACST) UTC+9:30', value: 'Australia/Adelaide' },
    { label: 'New Zealand (NZST) UTC+12:00', value: 'Pacific/Auckland' },
    { label: 'Fiji (FJT) UTC+12:00', value: 'Pacific/Fiji' },
    { label: 'Samoa (SST) UTC+13:00', value: 'Pacific/Apia' },

    // Atlantic / UTC
    { label: 'UTC (Coordinated Universal Time)', value: 'UTC' },
    { label: 'Azores (AZOT) UTC-1:00', value: 'Atlantic/Azores' },
    { label: 'Cape Verde (CVT) UTC-1:00', value: 'Atlantic/Cape_Verde' }
];

export default timezones;
